<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="模板名称">
                <el-input v-model="formInline.messageName" placeholder="模板名称"></el-input>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="formInline.platformId"  filterable clearable  placeholder="平台"  >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="formInline.status"  placeholder="状态"  >
                    <el-option v-for="item in statusData"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">拉取模板</el-button>
            </el-form-item>
        </el-form>
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="platformId" :formatter="platformProcess" label="平台" width="120"></el-table-column>
              <el-table-column prop="messageType" :formatter="messageTypeProcess" label="类型" width="120"></el-table-column>
                <el-table-column prop="messageName"  label="模板名称"></el-table-column>
                <el-table-column prop="messageNameOrigin"  label="模板原始名"></el-table-column>
                <el-table-column prop="templateId" label="模板Id"></el-table-column>
                <el-table-column prop="first"  label="头文本" sortable  width="180"></el-table-column>
                <el-table-column prop="topColor"  label="头颜色" sortable  width="80"></el-table-column>
                <el-table-column prop="remark"  label="尾文本" sortable  width="180"></el-table-column>
                <el-table-column prop="bottomColor"  label="尾颜色" sortable  width="80"></el-table-column>
                <el-table-column prop="url"  label="链接" sortable  width="180"></el-table-column>
                <el-table-column prop="creatTime" label="创建日期" sortable ></el-table-column>
                <el-table-column prop="status" label="状态" :formatter="statusProcess" sortable  ></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button-group style="margin-bottom:10px">
                            <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                            <el-tooltip class="item" effect="dark" content="导出订阅了这个模板的用户" placement="top-end">
                                <el-button type="success"  size="mini" v-show="scope.row.platformId==4"  @click="downLoad(scope.row)">导出</el-button>
                            </el-tooltip>
                            <el-button type="danger" v-show="false"  size="mini"  @click="handleDel(scope.row)">删除</el-button>
                            <el-tooltip class="item" effect="dark" content="点这里添加多套模板文案内容" placement="top-end">
                                <el-button type="warning"  size="mini"  @click="handleAddMore(scope.row)">更多</el-button>
                            </el-tooltip>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.messageId ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台"  :disabled="platformDisabled">
                        <el-option v-for="item in platformList"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模板名称">
                    <el-input v-model=form.messageName clearable   placeholder="模板名称"></el-input>
                </el-form-item>
                <el-form-item label="微信模板Id">
                    <el-input v-model=form.templateId clearable disabled="true"  placeholder="模板Id 复制小程序(公众号)后台中模板ID"></el-input>
                </el-form-item>
                <el-form-item label="头文本" v-show="formInline.platformId==1">
                    <el-input type="textarea"
                              :rows="5" v-model=form.first clearable  placeholder="头文本 "></el-input>
                    <span v-show="formInline.platformId==4">针对公众号模板消息 小程序模板消息没有头文本 不用填写</span>
                </el-form-item>
                <el-form-item label="头颜色" v-show="formInline.platformId==1">
                    <el-input v-model=form.topColor clearable  placeholder="头颜色"></el-input>
                </el-form-item>
                <el-form-item v-show="formInline.platformId==4">
<!--                    <el-button type="text" @click="bodyNew">新增Body</el-button>-->
                    <span style="color: red">值参照小程序(公众号)后台示例格式填写 (如要求是日期格式就不能写成汉字) 小程序限制值文案不能超过20个字符，超出后将不能被推送</span>
                </el-form-item>
                <el-form-item label="Body">
                    <el-table :data="body" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" width="180" >
                        <el-table-column type="index" label="序号" width="60">
                        </el-table-column>
                        <el-table-column prop="name" label="标题"  width="180">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.name disabled="disabled"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="Keyword"   width="180">
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.title  disabled="disabled"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="值" >
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.value clearable  placeholder="模板消息中右侧显示的内容(不要超过20个字)"></el-input>
                                <span v-show="form.platformId==4&&scope.row.value.length>20" style="color: red">文案超出长度限制,请修改!</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="颜色" >
                            <template slot-scope="scope">
                                <el-input v-model=scope.row.color clearable  placeholder="颜色"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="尾文本" v-show="formInline.platformId==1">
                    <el-input type="textarea"
                              :rows="5" v-model=form.remark clearable  placeholder="尾文本"></el-input>
                    <span v-show="formInline.platformId==4">针对公众号模板消息 小程序模板消息没有头文本 不用填写</span>
                </el-form-item>
                <el-form-item label="尾颜色" v-show="formInline.platformId==1">
                    <el-input v-model=form.bottomColor clearable  placeholder="尾颜色"></el-input>
                </el-form-item>
                <el-form-item label="URL" >
                    <el-input v-model="form.url"  clearable placeholder="连接参考 公众号连接 https://wx.lechun.cc 小程序连接: pages/home/index"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.status"  placeholder="状态">
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getRouterPageHash} from '@/api/http';
    import {listTemplateMessage,deleteTemplateMessage,saveTemplateMessage, downLoadSubscriptUser,selectTemplateMessage,getPlatformList,saveTemplateLogMessage,getPlatformList2,initWeixinTemplate} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                platformList:[],
                statusData:[{"id":0,"name":"禁用"},{"id":1,"name":"可用"}],
              messageTypeData:[{"value":1,"name":"客服消息"},{"value":2,"name":"模板消息"},{"value":4,"name":"MP订阅消息"}],
                loading:true,
                dialogFormVisible:false,
                form:{"messageId":0,"templateId":"","status":1,"variable":"","messageName":"","platformId":"","first":"","topColor":"","remark":"","bottomColor":"","url":"","status":1},
                formInline:{
                    platformId:0,
                    currentPage: 1,
                    status:1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                platformDisabled:false,
                platformGroupName:"",
                body:[]
            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList(this.formInline).then((res) => {
                //this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
            getPlatformList2(this.formInline).then((res) => {
                this.platformList=res.data;
                this.platformData=res.data;
            });
        },
        methods:{
            getList(){
                listTemplateMessage(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.messageList.total;
                    this.listData = res.data.messageList.list;
                    this.platformGroupName=res.data.platformGroupName;
                    //this.platformData=res.data.platFormList;
                    //this.mediaData=res.data.mediaList;
                    //this.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            downLoad(row){
                let url = `${downLoadSubscriptUser}?templateId=${row.templateId}&pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            handleDel(row){
                if(confirm("确定删除模板:"+row.messageName+"吗？")) {
                    deleteTemplateMessage({messageId: row.messageId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }

            },
            handleAdd(){
                initWeixinTemplate(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }

                });
            },
            handleAddMore(data){
                //添加多套文本内容
                this.$router.push({path: '/wechatTemplateMessageContent', query: {name: data.messageName, messageId: data.messageId}})
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                selectTemplateMessage({messageId:data.messageId}).then((res) => {
                    //console.log(res.data);
                    if(res.data.messageEntity!=undefined) {
                        this.form = res.data.messageEntity;
                        this.body=res.data.body;
                    }
                });
            },
            save(data){
                //console.log(data);
                if(data.platformId==""){
                    this.$message({
                        message:"请输入模板名称",
                        type:'error'
                    });
                    return;
                }
                if(data.messageName==""){
                    this.$message({
                        message:"请输入模板名称",
                        type:'error'
                    });
                    return;
                }
                if(data.templateId==""){
                    this.$message({
                        message:"请输入模板Id" ,
                        type:'error'
                    });
                    return;
                }
                if(data.status==""){
                    this.$message({
                        message:"请选择状态",
                        type:'error'
                    });
                    return;
                }
                data.variable=JSON.stringify(this.body);
                saveTemplateMessage(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }


                });

            },

            platformProcess(row, column, cellValue) {
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
                //return this.randData.name;

            },
            messageTypeProcess(row,column,cellValue){
              for(var key in this.messageTypeData){
                if(this.messageTypeData[key].value==cellValue) {
                  return this.messageTypeData[key].name;
                }
              }
            },
            statusProcess(row, column, cellValue) {
                for(var key in this.statusData){
                    if(this.statusData[key].id==cellValue) {
                        return this.statusData[key].name;
                    }
                }
            },
            bodyNew(){
                this.body.push({"title":"","value":"","color":""});
            },
            bodyNewDel(data){
                this.removeObjWithArr(this.body,data);
            },
            removeObjWithArr (_arr,_obj) {
                var length = _arr.length;
                for(var i = 0; i < length; i++)
                {
                    if(_arr[i] == _obj)
                    {
                        if(i == 0)
                        {
                            _arr.shift(); //删除并返回数组的第一个元素
                            return;
                        }
                        else if(i == length-1)
                        {
                            _arr.pop();  //删除并返回数组的最后一个元素
                            return;
                        }
                        else
                        {
                            _arr.splice(i,1); //删除下标为i的元素
                            return;
                        }
                    }
                }
            }


        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatTemplateMessageList.vue